import { CheckNotes, InspectionCase } from '../inspection-cases';

export class Standard_1205_part_6_Dto extends InspectionCase {
  plumbingPassedOpacityTest?: InspectionCase;
  systemComponentsDescriptionPassed?: InspectionCase;
}

export class Standard_1205_part_6 extends Standard_1205_part_6_Dto {
  constructor(data: Standard_1205_part_6_Dto = { title: 'תקן 1205 חלק 6' }) {
    super(data);
    this.plumbingPassedOpacityTest = new InspectionCase({
      ...data.plumbingPassedOpacityTest,
      title: 'הצנרת עמדה בבדיקת אטימות',
      section: '3.1.7'
    });
    this.systemComponentsDescriptionPassed = new InspectionCase({
      ...data.systemComponentsDescriptionPassed,
      title: 'תיאור מרכיבי המערכת – נבדק בהתאמה לתכנית/אישור מתכנן',
      section: '4.2.1'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.plumbingPassedOpacityTest.isApplicable ||
        this.plumbingPassedOpacityTest.isPassed) &&
        (!this.systemComponentsDescriptionPassed.isApplicable ||
          this.systemComponentsDescriptionPassed.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.plumbingPassedOpacityTest.getNotes(),
      ...this.systemComponentsDescriptionPassed.getNotes()
    ];
  }
}
